
import { api_host, api_auth} from '../../common/globals/constants';

export const getAvailabilityWeighted = (objective, begin, final, step, user, token) => 
    fetch(api_host+`/reporte/online/indicadores/AvailabilityHourCustomWeighted/?user=${user}&objetiveId=${objective}&step=${step}&fechaInicio=${begin}&fechaTermino=${final}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}&key=${api_auth}`)
.then(response => response.json())
